// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"fbe172c8","82":"45e79eab","247":"26a0726a","453":"2b55c83a","586":"c8cb2320","627":"7b56a659","653":"9826a60e","699":"1826b424","867":"f70e8f52","923":"95aa58f7","938":"c48579ed"}[chunkId] + ".chunk.js";
};